import { FileText, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

interface EmptyStateSectionProps {
  onCreateCase: () => void;
}

export function EmptyStateSection({ onCreateCase }: EmptyStateSectionProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center p-8 text-center space-y-4 bg-gradient-to-b from-amber-50/50 to-white rounded-lg border-2 border-dashed border-amber-200"
    >
      <div className="p-4 bg-amber-100 rounded-full">
        <FileText className="h-8 w-8 text-amber-600" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900">Ingen saker ennå</h3>
      <p className="text-gray-600 max-w-sm">
        Start din juridiske reise ved å opprette din første sak. Vi hjelper deg gjennom hele prosessen.
      </p>
      <Button
        onClick={onCreateCase}
        className="mt-4 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white shadow-lg hover:shadow-xl transition-all duration-300"
      >
        <Plus className="mr-2 h-4 w-4" />
        Opprett din første sak
      </Button>
    </motion.div>
  );
}